var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.435547C9.47852 0.435547 9.87891 0.611328 10.2793 1.01172L17.5059 8.4043C17.7988 8.70703 17.9453 9.05859 17.9453 9.47852C17.9453 10.3477 17.252 11.0508 16.3926 11.0508C15.9629 11.0508 15.5625 10.875 15.2402 10.5527L8.99023 4.10742L2.75 10.5527C2.42773 10.875 2.02734 11.0508 1.60742 11.0508C0.748047 11.0508 0.0546875 10.3477 0.0546875 9.47852C0.0546875 9.04883 0.201172 8.69727 0.494141 8.4043L7.7207 1.01172C8.10156 0.621094 8.51172 0.435547 9 0.435547Z",
    fill: "#9C85F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.8c5d1194a07577137501018f64520aef.svg";
export { ForwardRef as ReactComponent };